<section class="ftco-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="wrap d-md-flex">
                    <div class="img" style="background-image: url(assets/img/AM_media_logo.png);">
                    </div>
                    <div class="login-wrap p-4 p-md-5">
                        <div class="d-flex">
                            <div class="w-100">
                                <h3 class="mb-4">Admin Sign In</h3>
                            </div>
                            <div class="w-100">
                            </div>
                        </div>
                        <form [formGroup]="adminLoginForm" class="signin-form">
                            <div class="form-group mb-3">
                                <label class="label" for="name">Email</label>
                                <input type="text" formControlName="email" class="form-control" placeholder="Username"
                                    required>
                                <div class="form-error-message"
                                    *ngIf="adminLoginForm.get('email')?.invalid && adminLoginForm.get('email')?.touched">
                                    Email is required and must be enter valid email address.
                                </div>
                            </div>
                            <div class="form-group mb-3">
                                <label class="label" for="password">Password</label>
                                <input type="password" formControlName="password" class="form-control"
                                    placeholder="Password" required>
                                <div class="form-error-message"
                                    *ngIf="adminLoginForm.get('password')?.invalid && adminLoginForm.get('password')?.touched">
                                    Password is required and must be enter valid characters.
                                </div>
                            </div>
                            <div class="form-group">
                                <button type="submit" (click)="saveEventRegistration()"
                                    class="form-control btn btn-primary rounded submit px-3">Sign
                                    In</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>